import { useEffect } from 'react';
import { useDataContext } from './hooks/useDataContext';
import EpisodeList from './components/EpisodeList/EpisodeList';
import { AppProviderMain } from './context/EpisodePlayersContext';

function App(props) {
    const { setDataSource, isLoading, error } = useDataContext();
    const perView = props.postsPerView;

    useEffect(() => {
        setDataSource(props);
    }, []);

    if (isLoading) {
        return <div className="player-app__item-loading" />;
    }

    if (error) {
        return <div>Error occurred. Please try again!</div>;
    }

    return (
        <AppProviderMain>
            <EpisodeList perView={perView} />
        </AppProviderMain>
    );
}

export default App;
